import { datetimeFormatter } from '../../../shared/utils';
import { valueStringFormat } from '../../../shared/utils/formatters';
import { ColumnLabel } from '../models/ColumnLabel';
import { IGoodPractices } from '../models/GoodPractices';

type TableRowContentProps = {
  row: any;
  index: number;
  columns: string[];
  columnLabels: ColumnLabel;
  expandedRows: string[];
  handleToggleRow: (id: string) => void;
};

const TableRowContent = (props: TableRowContentProps) => {
  const { row, index, columns, columnLabels, expandedRows, handleToggleRow } = props;
  const isExpanded = expandedRows.includes(`${index}`);
  const subRows = ['detailLastUpdate', 'detailEventCoordinates', 'detailEvents'];

  return (
    <tr className='compactRow'>
      {columns.map(col => {
        if (subRows.includes(col)) return null;

        if (col === 'extraAction' && row.items.length > 0) {
          return (
            <td
              key={col}
              className='table-action'
              onClick={() => {
                handleToggleRow(`${index}`);
              }}
            >
              <span>
                <span className='btn btn-muted btn-icon-only'>
                  <span className={`rioglyph ${isExpanded ? 'rioglyph-chevron-up' : 'rioglyph-chevron-down'}`} />
                </span>
              </span>
            </td>
          );
        }

        if (col === 'tripStart' || col === 'tripFinal') {
          return (
            <td key={col} className='text-size-14' data-field={columnLabels[col]}>
              <span>{datetimeFormatter.format(new Date(row[col as keyof IGoodPractices]))}</span>
            </td>
          );
        }

        if (col === 'itOvernight' || col === 'itDayHours' || col === 'itTripHours') {
          const value = row[col as keyof IGoodPractices];
          return (
            <td key={col} className='text-size-14' data-field={columnLabels[col]}>
              <div
                style={{ minWidth: 90, textTransform: 'capitalize' }}
                className={value == 0 || !value ? 'label label-warning' : 'label label-success'}
              >
                {valueStringFormat(value)}
                {value == 1 ? ' Evento' : ' Eventos'}
              </div>
            </td>
          );
        }

        return (
          <td key={col} className='text-size-14' data-field={columnLabels[col]}>
            <span>{row[col as keyof IGoodPractices]}</span>
          </td>
        );
      })}
    </tr>
  );
};

export default TableRowContent;